<ycn-modal-base
    [modalBaseClass]="'modal-fix-scroll'"
    [extraModalClasses]="'modal-no-border user-select-none'"
    [open]="modalOpen"
    (closeModalHandler)="closeModal()">
    <ycn-simple-modal-header
        [header]="header"
        [showUnsavedStatus]="false"
        (closeModalHandler)="closeModal()">
    </ycn-simple-modal-header>
    <div class="modal-body">
        <div class="modal-section">
            <img [src]="chartEmbedUrl" (load)="hideLoadingSymbol()" style="width: 100%">
            <ycn-loading-symbol *ngIf="loading" [loaderMessage]="'Loading...'"></ycn-loading-symbol>
        </div>
    </div>
    <div class="modal-footer">
    </div>
</ycn-modal-base>
